var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.outletLock
        ? _c("div", { staticClass: "cart__outlet-notice" }, [
            _vm._v(
              "\n      Вы исчерпали лимит заказов, свяжитесь с оператором в онлайн-чате\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.orders.length > 0
        ? _c("div", { staticClass: "cart-done" }, [
            _c("div", { staticClass: "cart-done__pic" }, [
              _c("svg", { staticClass: "icon icon--plant cart-done__icon" }, [
                _c("use", { attrs: { "xlink:href": "#icon-plant" } })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "cart-done__thanks" }, [
                _vm._v("Спасибо")
              ])
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.orders, function(order, index) {
        return _c(
          "div",
          [
            _c("basket-items-list", {
              key: index,
              attrs: {
                "read-only": "",
                finish: "",
                "show-title": "",
                "show-coupons": index === _vm.orders.length - 1,
                "order-number": order.id,
                outlet: order.outlet
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "cart-info" }, [
              _c("div", { staticClass: "cart-info__col" }, [
                _c("p", { staticClass: "cart-info__title" }, [
                  _vm._v("Информация о доставке")
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "cart-info__list" }, [
                  _c("li", { staticClass: "cart-info__item" }, [
                    _c("span", { staticClass: "cart-info__key" }, [
                      _vm._v("Имя")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cart-info__value" }, [
                      _vm._v(_vm._s(_vm.form.firstName))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "cart-info__item" }, [
                    _c("span", { staticClass: "cart-info__key" }, [
                      _vm._v("Фамилия")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cart-info__value" }, [
                      _vm._v(_vm._s(_vm.form.lastName))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "cart-info__item" }, [
                    _c("span", { staticClass: "cart-info__key" }, [
                      _vm._v("Адрес")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cart-info__value" }, [
                      _vm._v(
                        _vm._s(_vm.form.city) +
                          " " +
                          _vm._s(_vm.form.street) +
                          " " +
                          _vm._s(_vm.form.house) +
                          " " +
                          _vm._s(_vm.form.flat)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "cart-info__item" }, [
                    _c("span", { staticClass: "cart-info__key" }, [
                      _vm._v("Телефон")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cart-info__value" }, [
                      _vm._v(_vm._s(_vm.form.phone))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "cart-info__item" }, [
                    _c("span", { staticClass: "cart-info__key" }, [
                      _vm._v("E-mail")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cart-info__value" }, [
                      _vm._v(_vm._s(_vm.form.email))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cart-info__col" }, [
                _c("p", { staticClass: "cart-info__title" }, [
                  _vm._v("Способ доставки и оплаты")
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "cart-info__list" }, [
                  _c("li", { staticClass: "cart-info__item" }, [
                    _c("span", { staticClass: "cart-info__key" }, [
                      _vm._v("Оплата")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cart-info__value" }, [
                      _vm._v(_vm._s(_vm.getPaymentType))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "cart-info__item" }, [
                    _c("span", { staticClass: "cart-info__key" }, [
                      _vm._v("Доставка")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cart-info__value" }, [
                      _vm._v(_vm._s(_vm.getDeliveryType))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cart-info__col" }, [
                _c("p", { staticClass: "cart-info__title" }, [
                  _vm._v("Информация о заказе")
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "cart-info__list" }, [
                  _c("li", { staticClass: "cart-info__item" }, [
                    _c("span", { staticClass: "cart-info__key" }, [
                      _vm._v("Стоимость")
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "cart-info__value cart-info__value--right",
                      domProps: { innerHTML: _vm._s(order.base_price) }
                    })
                  ]),
                  _vm._v(" "),
                  order.discount
                    ? _c("li", { staticClass: "cart-info__item" }, [
                        _c("span", { staticClass: "cart-info__key" }, [
                          _vm._v("Скидка")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "cart-info__value cart-info__value--right"
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "icon icon--circle_minus cart-info__icon"
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-circle_minus" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(order.discount.toFixed(2))
                              }
                            })
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  order.delivery_price
                    ? _c("li", { staticClass: "cart-info__item" }, [
                        _c("span", { staticClass: "cart-info__key" }, [
                          _vm._v("Доставка")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "cart-info__value cart-info__value--right"
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "icon icon--circle_plus cart-info__icon"
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-circle_plus" }
                                })
                              ]
                            ),
                            _vm._v(
                              "\n                        " +
                                _vm._s(order.delivery_price) +
                                "\n                    "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("li", { staticClass: "cart-info__item" }, [
                    _c("span", { staticClass: "cart-info__key" }, [
                      _vm._v("Сумма заказа")
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "cart-info__value cart-info__value--right cart-info__value--total",
                      domProps: { innerHTML: _vm._f("price")(order.price) }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cart__btn-container" }, [
                index === _vm.orders.length - 1
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn--blue cart__btn",
                        attrs: { href: "/" }
                      },
                      [_vm._v("На главную страницу")]
                    )
                  : _vm._e()
              ])
            ])
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cart-done__main" }, [
      _c("p", { staticClass: "cart-done__title" }, [
        _vm._v("Спасибо за покупку!")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }